import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import type { UserInfo } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useGetUserInfo = (): UseQueryResult<UserInfo> => {
    return useQuery({
        queryKey: aiAgentQueryKeys.userInfo(),
        queryFn: async ({ signal }) => {
            const data = await salesApiService.aiAgent.meeting.getUserInfo({ cancellation: signal });
            return data;
        },
    });
};
